import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);
// 登錄验证
export default new Vuex.Store({
    state: {
        user: false
    },
    mutations: {
        // 登錄
        login(state, user) {
            state.user = user;
            localStorage.setItem("userInfo", user);
        },
        // 退出
        logout(state, user) {
            state.user = "";
            localStorage.setItem("userInfo", "");
        }
    }
})


// WEBPACK FOOTER //
// ./src/vuex/store.js